import { useEffect, useState } from 'react';

import { getAllGenres } from '../services/GenreServices';
import { getAllCategories } from '../services/CategoryServices';
import { getAllProducts } from '../services/ProductServices';

// Live genres, categories and products, fetched once per page load and shared by the header,
// mega menu, home page and footer. Call refreshCatalog() after admin edits.
let cache = null;

const load = () => {
    cache = cache || Promise.all([getAllGenres(), getAllCategories(), getAllProducts()])
        .then(([g, c, p]) => ({
            genres: (g.allGenres || []).filter(x => x.status),
            categories: (c.allCategories || []).filter(x => x.status),
            products: (p.allProducts || []).filter(x => x.status),
        }))
        .catch(() => { cache = null; return { genres: [], categories: [], products: [] }; });
    return cache;
};

export const refreshCatalog = () => { cache = null; };

// A category's thumbnail is its newest product's photo
export const categoryImage = (products, categoryId) =>
    [...products].reverse().find(p => p.category === categoryId)?.imageUrl;

const useCatalog = () => {
    const [catalog, setCatalog] = useState({ genres: [], categories: [], products: [], loading: true });
    useEffect(() => {
        let alive = true;
        load().then(data => alive && setCatalog({ ...data, loading: false }));
        return () => { alive = false; };
    }, []);
    return catalog;
};

export default useCatalog;
